'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    (function (Quiz, $) {
        'use strict';

        var $dom = {};

        var cacheDom = function cacheDom() {

            $dom.quizLoader = $('[data-quiz-loader]');
            $dom.quizInner = $('.c-quiz__inner');
            $dom.quizClick = $('[data-quiz-click]');
            $dom.quizClickDesktop = $('[data-quiz-desktop]');
            $dom.quizClickContinue = $('[data-quiz-continue]');
            $dom.quizModal = $('[data-quiz-modal]');
            $dom.quizClose = $('[data-quiz-close]');
            $dom.quizStepFront = $('[data-step-front]');
            $dom.quizStepOne = $('[data-step-one]');
            $dom.quizStepTwo = $('[data-step-two]');
            $dom.quizStepThree = $('[data-step-three]');
            $dom.quizStepFour = $('[data-step-four]');
            $dom.quizStepResult = $('[data-step-result]');
            $dom.quizBackStepOne = $('[data-back-stepone]');
            $dom.quizBackStepTwo = $('[data-back-steptwo]');
            $dom.quizBackStepThree = $('[data-back-stepthree]');
            $dom.quizBtnStepOne = $('[data-button-stepone]');
            $dom.quizBtnStepTwo = $('[data-button-steptwo]');
            $dom.quizBtnStepThree = $('[data-button-stepthree]');
            $dom.quizBtnStepFour = $('[data-button-stepfour]');
            $dom.quizOutter = $('.c-quiz__outter');
            $dom.quizOverlay = $('.c-quiz__overlay');
            $dom.quizStepBarText = $('.c-quizStepBar__text');
            $dom.quizStepBar = $('.c-quizStepBar__bar span');
            $dom.quizContinueBar = $('.c-quiz__continueBar span');
            $dom.quizMainDiv = $('.c-quiz__main');
            $dom.quizBlockListType = $('[data-step-one] .c-quizBlockList__row .c-quizBlockList__box');
            $dom.quizListEvent = $('.c-quizList__row .c-quizList__name');
            $dom.quizBlockListClimate = $('[data-step-three] .c-quizBlockList__row .c-quizBlockList__box');
            $dom.quizBlockListAge = $('.c-quizListAge__row .c-quizListAge__name');
            $dom.quizResult = $('.c-quizResult');
            $dom.quizStepOneAnswer = $('[data-step-one-answer]');
            $dom.quizStepTwoAnswer = $('[data-step-two-answer]');
            $dom.quizStepThreeAnswer = $('[data-step-three-answer]');
            $dom.quizStepFourAnswer = $('[data-step-four-answer]');
            $dom.quizResultCopy = $('.c-quizResult__copy');
            $dom.quizResultRow = $('.c-quizResult__row');
            $dom.quizResultDays = $('.c-quizResult__title');
            $dom.quizRecurringDays = $('.c-quizResult__recurring-days');
            // $dom.quizResultDrops = $('.c-quizResult__drops');
            $dom.quizAddToCart = $('.js-quiz-result-atc');
        };

        var recomendedProducts = Array.from(document.querySelectorAll('.c-quizResult__product'));
        var addToCartBtnText = document.querySelector('.c-productInfo__btnText');

        var bindUIActions = function bindUIActions() {

            var setListAnswer = [];
            var setListAnswerText = [];

            if (localStorage.getItem("quizAnswerTwo") !== null) {
                var getTwoAnswerValue = localStorage.getItem("quizAnswerTwo", setListAnswer);
                var getTwoAnswerValueReplace = getTwoAnswerValue.replace(/["]/g, "");
                var setTwoAnswerValue = getTwoAnswerValueReplace.split(',');

                JSON.stringify(setListAnswer).replace(/]|[[]/g, '');

                for (var i = 0; i < setTwoAnswerValue.length; i++) {
                    setTwoAnswerValue[i] = setTwoAnswerValue[i].replace(/^\s*/, "").replace(/\s*$/, "");
                    setListAnswer.push(setTwoAnswerValue[i]);
                }
            }

            function quizToken(name, value) {
                var date = new Date();
                date.setTime(date.getTime() + 2 * 3600 * 1000);
                var expires = "; expires=" + date.toGMTString();
                document.cookie = name + "=" + value + expires + "; path=/";
            }

            function initPopup() {
                $('html, body').addClass('quiz-scroll-hidden');
                $dom.quizModal.removeClass('is-down');
                $dom.quizModal.addClass('is-open');
                $dom.quizMainDiv.addClass('quiz-step-one');
                $dom.quizStepOne.addClass('is-active');
                $dom.quizStepBarText.text('Step 1 of 4');
                $dom.quizModal.removeClass('is-hide-desktop');
            }

            function quizBtnStepOne() {
                $dom.quizBackStepOne.show();
                $dom.quizBackStepTwo.hide();
                $dom.quizBackStepThree.hide();
                $dom.quizMainDiv.removeClass('quiz-step-one');
                $dom.quizMainDiv.addClass('quiz-step-two');
                $dom.quizStepOne.removeClass('is-active');
                $dom.quizStepOne.addClass('is-done');
                $dom.quizStepTwo.addClass('is-active');
                $dom.quizStepBarText.text('Step 2 of 4');
            }

            function quizBtnStepTwo() {
                $dom.quizBackStepOne.hide();
                $dom.quizBackStepTwo.show();
                $dom.quizBackStepThree.hide();
                $dom.quizMainDiv.removeClass('quiz-step-two');
                $dom.quizMainDiv.addClass('quiz-step-three');
                $dom.quizStepTwo.removeClass('is-active');
                $dom.quizStepTwo.addClass('is-done');
                $dom.quizStepThree.addClass('is-active');
                $dom.quizStepBarText.text('Step 3 of 4');
            }

            function quizBtnStepThree() {
                $dom.quizBackStepOne.hide();
                $dom.quizBackStepTwo.hide();
                $dom.quizBackStepThree.show();
                $dom.quizMainDiv.removeClass('quiz-step-two');
                $dom.quizMainDiv.removeClass('quiz-step-three');
                $dom.quizMainDiv.addClass('quiz-step-four');
                $dom.quizStepTwo.removeClass('is-active');
                $dom.quizStepTwo.addClass('is-done');
                $dom.quizStepThree.removeClass('is-active');
                $dom.quizStepThree.addClass('is-done');
                $dom.quizStepFour.addClass('is-active');
                $dom.quizStepBarText.text('Step 4 of 4');
            }

            function quizBtnStepFour() {
                $dom.quizStepFour.removeClass('is-active');
                $dom.quizStepFour.addClass('is-done');
                $dom.quizBackStepOne.hide();
                $dom.quizBackStepTwo.hide();
                $dom.quizBackStepThree.hide();
                $('.c-quizStepBar__main ').hide();
                setTimeout(function () {
                    $dom.quizMainDiv.removeClass('quiz-step-four');
                    $dom.quizMainDiv.addClass('quiz-step-result');
                    $dom.quizStepResult.addClass('is-active');

                    var selectedOneAnswerHtml = $dom.quizStepOneAnswer.find('.c-quizBlockList__box.is-active').html();
                    var selectedThreeAnswerHtml = $dom.quizStepThreeAnswer.find('.c-quizBlockList__box.is-active').html();

                    localStorage.setItem('quizAnswerOneIcon', selectedOneAnswerHtml);
                    localStorage.setItem('quizAnswerThreeIcon', selectedThreeAnswerHtml);

                    $dom.quizResultRow.empty();
                    $dom.quizResultRow.append("<div class='c-quizResult__item'>" + selectedOneAnswerHtml + "</div>");
                    $dom.quizResultRow.append("<div class='c-quizResult__item'>" + selectedThreeAnswerHtml + "</div>");
                }, 500);
            }

            function quizSubmitDone() {
                setTimeout(function () {
                    $('html, body').removeClass('quiz-scroll-hidden');
                    $dom.quizModal.removeClass('is-open');
                    $dom.quizBackStepOne.removeAttr('style');
                    $dom.quizBackStepTwo.removeAttr('style');
                    $dom.quizStepFront.addClass('is-active-front');
                    $dom.quizStepFront.removeClass('is-done-front');
                    $dom.quizStepOne.removeClass('is-done');
                    $dom.quizStepTwo.removeClass('is-done');
                    $dom.quizStepThree.removeClass('is-done');
                    $dom.quizStepFour.removeClass('is-done');
                    $dom.quizMainDiv.removeClass('quiz-step-result');
                    $dom.quizStepResult.removeClass('is-active');
                    $dom.quizBlockListType.removeClass('is-active');
                    $dom.quizListEvent.removeClass('is-active');
                    $dom.quizBlockListClimate.removeClass('is-active');
                    $dom.quizBlockListAge.removeClass('is-active');
                    $('.c-quizResult__bar').removeClass('is-open');
                    $('body').removeClass('is-reco-open');
                    $dom.quizStepBarText.text('Step 1 of 4');
                    $dom.quizStepBar.css('width', '0');
                    $dom.quizContinueBar.css('width', '0');
                }, 1200);
                setTimeout(function () {
                    $dom.quizBtnStepOne.addClass('disabled');
                    $dom.quizBtnStepTwo.addClass('disabled');
                    $dom.quizBtnStepThree.addClass('disabled');
                    $dom.quizBtnStepFour.addClass('disabled');

                    $(window).scrollTop(0);

                    $dom.quizResult.slideDown();

                    if ($(window).scrollTop() == 0) {
                        $dom.quizResult.addClass('is-open');
                        $dom.quizResult.addClass('c-quizSubmitted');
                    }
                    $('.c-quizStepBar__main ').removeAttr("style");
                }, 1500);
            }

            function backStepOne() {
                $dom.quizBackStepOne.hide();
                $dom.quizBackStepTwo.hide();
                $dom.quizBackStepThree.hide();
                $dom.quizMainDiv.removeClass('quiz-step-two');
                $dom.quizMainDiv.addClass('quiz-step-one');
                $dom.quizStepTwo.removeClass('is-active');
                $dom.quizStepOne.removeClass('is-done');
                $dom.quizStepOne.addClass('is-active');
                $dom.quizStepBarText.text('Step 1 of 4');
                $dom.quizStepBar.css('width', '0px');
                $dom.quizContinueBar.css('width', '0px');
            }

            function backStepTwo() {
                $dom.quizBackStepOne.show();
                $dom.quizBackStepTwo.hide();
                $dom.quizBackStepThree.hide();
                $dom.quizMainDiv.removeClass('quiz-step-three');
                $dom.quizMainDiv.addClass('quiz-step-two');
                $dom.quizStepThree.removeClass('is-active');
                $dom.quizStepTwo.removeClass('is-done');
                $dom.quizStepTwo.addClass('is-active');
                $dom.quizStepBarText.text('Step 2 of 4');
                $dom.quizStepBar.css('width', '50%');
                $dom.quizContinueBar.css('width', '50%');
            }

            function backStepThree() {
                $dom.quizBackStepOne.hide();
                $dom.quizBackStepTwo.show();
                $dom.quizBackStepThree.hide();
                $dom.quizMainDiv.removeClass('quiz-step-four');
                $dom.quizMainDiv.addClass('quiz-step-three');
                $dom.quizStepFour.removeClass('is-active');
                $dom.quizStepThree.removeClass('is-done');
                $dom.quizStepThree.addClass('is-active');
                $dom.quizStepBarText.text('Step 3 of 4');
                $dom.quizStepBar.css('width', '75%');
                $dom.quizContinueBar.css('width', '75%');
            }

            function checkUser() {

                // Klaviyo Info
                var getKlaviyoEmail = _learnq.identify().$email;
                var getKlaviyoName = _learnq.identify().$first_name;

                // customerEmail is defined in theme.liquid file.

                if (customerEmail !== "") {
                    //userInfo.push(customerName , customerEmail );
                    localStorage.setItem('quizuseremail', customerEmail);
                    localStorage.setItem('quizusername', customerName);
                } else if (getKlaviyoEmail !== undefined) {
                    //userInfo.push(getKlaviyoName , getKlaviyoEmail);
                    localStorage.setItem('quizuseremail', getKlaviyoEmail);

                    if (getKlaviyoName !== undefined) {
                        localStorage.setItem('quizusername', getKlaviyoName);
                    }
                }
            }

            function getToken() {
                if (document.cookie.indexOf("quizToken=") >= 0) {} else {
                    localStorage.removeItem('quiztoken');
                }

                if (localStorage.getItem("quiztoken") === null) {
                    $.ajax({
                        type: 'POST',
                        url: 'https://api.calderalab.com/api/user',
                        data: {
                            "email": localStorage.getItem('quizuseremail'),
                            "name": localStorage.getItem('quizusername')
                        },
                        success: function success(data) {
                            var usertoken = data.data.token;
                            var uid = data.data.id;

                            //console.log(data);

                            //console.log(uid);

                            if (document.cookie.indexOf("quizToken=") >= 0) {} else {
                                localStorage.setItem('quiztoken', usertoken);
                                quizToken("quizToken", "true");
                            }

                            if (localStorage.getItem("quizuseremail") === null) {
                                localStorage.setItem('quizuserid', uid);
                            }

                            setTimeout(function () {
                                if (localStorage.getItem("quizuseremail") === null) {
                                    linkUser();
                                }
                                getQuiz();
                            }, 1000);
                        },
                        error: function error(xhr, status) {
                            //console.log('error' , 'getToken function not fired' );
                        }
                    });
                } else {
                    if (localStorage.getItem("quizuseremail") !== null) {
                        if (localStorage.getItem("quizuserid") !== null) {
                            setTimeout(function () {
                                linkUser();
                            }, 1000);
                        }
                    }
                    getQuiz();
                }
            }

            function saveQuizFirstStep() {
                var getValueOne = localStorage.getItem("quizAnswerOne");
                $dom.quizStepOne.find('.c-quizBlockList__row .c-quizBlockList__item').each(function () {
                    var getAnswerValueOne = $(this).find('.c-quizBlockList__name').attr('data-id');

                    if (getValueOne === getAnswerValueOne) {
                        $(this).find('.c-quizBlockList__box').addClass('is-active');
                        $dom.quizStepBar.css('width', '25%');
                        $dom.quizContinueBar.css('width', '25%');
                        $dom.quizBtnStepOne.removeClass('disabled');
                    }
                });
            }

            function saveQuizSecondStep() {
                $dom.quizStepTwo.find('.c-quizList__row .c-quizList__item').each(function () {
                    var getAnswerValueTwo = $(this).find('.c-quizList__name').attr('data-id');
                    for (var i = 0; i < setListAnswer.length; i++) {
                        if (setListAnswer[i] == getAnswerValueTwo) {
                            $(this).find('.c-quizList__name').addClass('is-active');
                            $dom.quizStepBar.css('width', '50%');
                            $dom.quizContinueBar.css('width', '50%');
                            $dom.quizBtnStepTwo.removeClass('disabled');
                            $dom.quizStepOne.addClass('is-done');
                            $dom.quizStepOne.removeClass('is-active');
                        }
                    }
                });
            }

            function saveQuizThirdStep() {
                var getValueThree = localStorage.getItem("quizAnswerThree");
                $dom.quizStepThree.find('.c-quizBlockList__row .c-quizBlockList__item').each(function () {
                    var getAnswerValueThree = $(this).find('.c-quizBlockList__name').attr('data-id');

                    if (getValueThree === getAnswerValueThree) {
                        $(this).find('.c-quizBlockList__box').addClass('is-active');
                        $dom.quizBtnStepOne.removeClass('disabled');
                        $dom.quizBtnStepTwo.removeClass('disabled');
                        $dom.quizBtnStepThree.removeClass('disabled');
                        $dom.quizStepBar.css('width', '75%');
                        $dom.quizContinueBar.css('width', '75%');
                        $dom.quizStepOne.addClass('is-done');
                        $dom.quizStepOne.removeClass('is-active');
                    }
                });
            }

            function saveQuizFourStep() {
                var getValueFour = localStorage.getItem("quizAnswerFour");
                $dom.quizStepFour.find('.c-quizListAge__row .c-quizListAge__item').each(function () {
                    var getAnswerValueFour = $(this).find('.c-quizListAge__name').attr('data-id');

                    if (getValueFour === getAnswerValueFour) {
                        $(this).find('.c-quizListAge__name').addClass('is-active');
                        $dom.quizBtnStepOne.removeClass('disabled');
                        $dom.quizBtnStepTwo.removeClass('disabled');
                        $dom.quizBtnStepThree.removeClass('disabled');
                        $dom.quizBtnStepFour.removeClass('disabled');
                        $dom.quizStepBar.css('width', '100%');
                        $dom.quizContinueBar.css('width', '100%');
                        $dom.quizStepOne.addClass('is-done');
                        $dom.quizStepOne.removeClass('is-active');
                    }
                });
            }

            function saveQuiz() {
                if (localStorage.getItem("quizStep") === 'one') {
                    saveQuizFirstStep();
                } else if (localStorage.getItem("quizStep") === 'two') {
                    saveQuizFirstStep();
                    saveQuizSecondStep();
                    quizBtnStepOne();
                } else if (localStorage.getItem("quizStep") === 'three') {
                    saveQuizFirstStep();
                    saveQuizSecondStep();
                    saveQuizThirdStep();
                    quizBtnStepTwo();
                } else if (localStorage.getItem("quizStep") === 'four') {
                    saveQuizFirstStep();
                    saveQuizSecondStep();
                    saveQuizThirdStep();
                    saveQuizFourStep();
                    quizBtnStepThree();
                }
            }

            function linkUser() {
                var uid = localStorage.getItem('quizuserid');
                $.ajax({
                    type: 'PATCH',
                    url: 'https://api.calderalab.com/api/user/' + uid,
                    data: {
                        "email": localStorage.getItem('quizuseremail'),
                        "name": localStorage.getItem('quizusername')
                    },
                    success: function success(data) {
                        //console.log('link user' , data);
                    },
                    error: function error(xhr, status) {
                        //console.log('error' , 'user email already linked' );
                    }
                });
            }

            function getQuiz() {
                var token = localStorage.getItem('quiztoken');
                $.ajax({
                    type: 'GET',
                    url: 'https://api.calderalab.com/api/quiz',
                    beforeSend: function beforeSend(xhr) {
                        xhr.setRequestHeader("Authorization", 'Bearer ' + token);
                        $dom.quizLoader.addClass('is-active');
                    },
                    success: function success(data) {
                        //console.log('getQuiz success', data);
                        var quizId = data.data.quizId;
                        localStorage.setItem('quizId', quizId);
                        var quizQuestions = data.data.questions;

                        $dom.quizLoader.removeClass('is-active');
                        $dom.quizInner.removeClass('is-hide');

                        $dom.quizStepOne.attr('data-question-id', data.data.questions[0].id);
                        $dom.quizStepOne.find('.c-quizStep__heading').text(data.data.questions[0].description);
                        $dom.quizStepOneAnswer.find('.c-quizBlockList__item:nth-child(3) span').text(data.data.questions[0].options[0].description);
                        $dom.quizStepOneAnswer.find('.c-quizBlockList__item:nth-child(3) span').attr('data-id', data.data.questions[0].options[0].id);
                        $dom.quizStepOneAnswer.find('.c-quizBlockList__item:nth-child(1) span').text(data.data.questions[0].options[1].description);
                        $dom.quizStepOneAnswer.find('.c-quizBlockList__item:nth-child(1) span').attr('data-id', data.data.questions[0].options[1].id);
                        $dom.quizStepOneAnswer.find('.c-quizBlockList__item:nth-child(2) span').text(data.data.questions[0].options[2].description);
                        $dom.quizStepOneAnswer.find('.c-quizBlockList__item:nth-child(2) span').attr('data-id', data.data.questions[0].options[2].id);

                        $dom.quizStepTwo.attr('data-question-id', data.data.questions[1].id);
                        $dom.quizStepTwo.find('.c-quizStep__heading').text(data.data.questions[1].description);
                        /*$.each(data.data.questions[1].options, function(i, options){
                          $dom.quizStepTwoAnswer.append("<div class='c-quizList__item'><span class='c-quizList__name' data-id='" +options.id+ "'>" + options.description +  "</span></div>");
                        });*/
                        $dom.quizStepTwoAnswer.find('.c-quizList__item:nth-child(1) span').text(data.data.questions[1].options[0].description);
                        $dom.quizStepTwoAnswer.find('.c-quizList__item:nth-child(1) span').attr('data-id', data.data.questions[1].options[0].id);
                        $dom.quizStepTwoAnswer.find('.c-quizList__item:nth-child(2) span').text(data.data.questions[1].options[1].description);
                        $dom.quizStepTwoAnswer.find('.c-quizList__item:nth-child(2) span').attr('data-id', data.data.questions[1].options[1].id);
                        $dom.quizStepTwoAnswer.find('.c-quizList__item:nth-child(3) span').text(data.data.questions[1].options[2].description);
                        $dom.quizStepTwoAnswer.find('.c-quizList__item:nth-child(3) span').attr('data-id', data.data.questions[1].options[2].id);
                        $dom.quizStepTwoAnswer.find('.c-quizList__item:nth-child(4) span').text(data.data.questions[1].options[3].description);
                        $dom.quizStepTwoAnswer.find('.c-quizList__item:nth-child(4) span').attr('data-id', data.data.questions[1].options[3].id);
                        $dom.quizStepTwoAnswer.find('.c-quizList__item:nth-child(5) span').text(data.data.questions[1].options[4].description);
                        $dom.quizStepTwoAnswer.find('.c-quizList__item:nth-child(5) span').attr('data-id', data.data.questions[1].options[4].id);
                        $dom.quizStepTwoAnswer.find('.c-quizList__item:nth-child(6) span').text(data.data.questions[1].options[5].description);
                        $dom.quizStepTwoAnswer.find('.c-quizList__item:nth-child(6) span').attr('data-id', data.data.questions[1].options[5].id);

                        $dom.quizStepThree.attr('data-question-id', data.data.questions[2].id);
                        $dom.quizStepThree.find('.c-quizStep__heading').text(data.data.questions[2].description);
                        $dom.quizStepThreeAnswer.find('.c-quizBlockList__item:nth-child(1) span').text(data.data.questions[2].options[0].description);
                        $dom.quizStepThreeAnswer.find('.c-quizBlockList__item:nth-child(1) span').attr('data-id', data.data.questions[2].options[0].id);
                        $dom.quizStepThreeAnswer.find('.c-quizBlockList__item:nth-child(2) span').text(data.data.questions[2].options[1].description);
                        $dom.quizStepThreeAnswer.find('.c-quizBlockList__item:nth-child(2) span').attr('data-id', data.data.questions[2].options[1].id);
                        $dom.quizStepThreeAnswer.find('.c-quizBlockList__item:nth-child(3) span').text(data.data.questions[2].options[2].description);
                        $dom.quizStepThreeAnswer.find('.c-quizBlockList__item:nth-child(3) span').attr('data-id', data.data.questions[2].options[2].id);
                        $dom.quizStepThreeAnswer.find('.c-quizBlockList__item:nth-child(4) span').text(data.data.questions[2].options[3].description);
                        $dom.quizStepThreeAnswer.find('.c-quizBlockList__item:nth-child(4) span').attr('data-id', data.data.questions[2].options[3].id);

                        $dom.quizStepFour.attr('data-question-id', data.data.questions[3].id);
                        $dom.quizStepFour.find('.c-quizStep__heading').text(data.data.questions[3].description);

                        $dom.quizStepFourAnswer.find('.c-quizListAge__item:nth-child(1) span').text(data.data.questions[3].options[0].description);
                        $dom.quizStepFourAnswer.find('.c-quizListAge__item:nth-child(1) span').attr('data-id', data.data.questions[3].options[0].id);
                        $dom.quizStepFourAnswer.find('.c-quizListAge__item:nth-child(2) span').text(data.data.questions[3].options[1].description);
                        $dom.quizStepFourAnswer.find('.c-quizListAge__item:nth-child(2) span').attr('data-id', data.data.questions[3].options[1].id);
                        $dom.quizStepFourAnswer.find('.c-quizListAge__item:nth-child(3) span').text(data.data.questions[3].options[2].description);
                        $dom.quizStepFourAnswer.find('.c-quizListAge__item:nth-child(3) span').attr('data-id', data.data.questions[3].options[2].id);
                        $dom.quizStepFourAnswer.find('.c-quizListAge__item:nth-child(4) span').text(data.data.questions[3].options[3].description);
                        $dom.quizStepFourAnswer.find('.c-quizListAge__item:nth-child(4) span').attr('data-id', data.data.questions[3].options[3].id);
                        $dom.quizStepFourAnswer.find('.c-quizListAge__item:nth-child(5) span').text(data.data.questions[3].options[4].description);
                        $dom.quizStepFourAnswer.find('.c-quizListAge__item:nth-child(5) span').attr('data-id', data.data.questions[3].options[4].id);
                        $dom.quizStepFourAnswer.find('.c-quizListAge__item:nth-child(6) span').text(data.data.questions[3].options[5].description);
                        $dom.quizStepFourAnswer.find('.c-quizListAge__item:nth-child(6) span').attr('data-id', data.data.questions[3].options[5].id);

                        saveQuiz();
                    },
                    error: function error(xhr, status) {
                        //console.log('error' , 'getQuiz function not fired' );
                    }
                });
            }

            function pushToKlaviyo() {
                var email = localStorage.getItem("quizuseremail");
                $('.c-quizKlaviyo input[type=email]').attr('value', email);

                setTimeout(function () {
                    document.getElementById("js-quiz-submit-btn").click();
                }, 1500);

                KlaviyoSubscribe.attachToForms('#quiz_signup', {
                    hide_form_on_success: true,
                    extra_properties: {
                        $first_name: localStorage.getItem("quizusername"),
                        'Quiz Answer One': localStorage.getItem("quizAnswerOneText"),
                        'Quiz Answer Two': localStorage.getItem("quizAnswerTwoText"),
                        'Quiz Answer Three': localStorage.getItem("quizAnswerThreeText"),
                        'Quiz Answer Four': localStorage.getItem("quizAnswerFourText")
                    },
                    success: function success($form) {
                        _learnq.push(['identify', { $first_name: localStorage.getItem("quizusername") }]);
                    }
                });
            }

            function submitQuiz() {
                var token = localStorage.getItem('quiztoken');
                var quizId = localStorage.getItem('quizId');

                $.ajax({
                    type: 'POST',
                    url: 'https://api.calderalab.com/api/submission/quiz',
                    beforeSend: function beforeSend(xhr) {
                        xhr.setRequestHeader("Authorization", 'Bearer ' + token);
                    },
                    data: {
                        "submission": {
                            "quizId": localStorage.getItem('quizId'),
                            "questionOptions": [{
                                "questionId": $dom.quizStepOne.attr('data-question-id'),
                                "optionIds": [localStorage.getItem('quizAnswerOne')]
                            }, {
                                "questionId": $dom.quizStepTwo.attr('data-question-id'),
                                "optionIds": localStorage.getItem('quizAnswerTwo').split(',')
                            }, {
                                "questionId": $dom.quizStepThree.attr('data-question-id'),
                                "optionIds": [localStorage.getItem('quizAnswerThree')]
                            }, {
                                "questionId": $dom.quizStepFour.attr('data-question-id'),
                                "optionIds": [localStorage.getItem('quizAnswerFour')]
                            }]
                        }
                    },
                    success: function success(data) {
                        //console.log('submitQuiz success', data);
                        $dom.quizStepTwo.find('.c-quizList__row .c-quizList__item').each(function () {
                            if ($(this).find('.c-quizList__name').hasClass('is-active')) {
                                var getAnswerTwo = $(this).find('.c-quizList__name').text();
                                setListAnswerText.push(getAnswerTwo);
                            }
                        });
                        localStorage.setItem("quizAnswerTwoText", setListAnswerText.join(', '));
                        $dom.quizResultCopy.text(data.data.resultDescription);
                        $dom.quizResultDays.text('Ships Every ' + data.data.metaData.days + ' Days');
                        $dom.quizRecurringDays.text(data.data.metaData.days);
                        // $dom.quizResultDrops.text(data.data.metaData.noOfDrops);
                        localStorage.setItem('quizDrops', data.data.metaData.noOfDrops);
                        localStorage.setItem('quizDays', data.data.metaData.days);
                        localStorage.setItem('quizDescription', data.data.resultDescription);

                        if (window.location.href.indexOf("the-regimen") > -1) {
                            if (localStorage.getItem("quizuseremail") !== null) {
                                pushToKlaviyo();
                            }
                            quizSubmitDone();

                            // Quiz Push Data layer

                            var quizAnswerTwoProperties = localStorage.getItem('quizAnswerTwoText').split(',');
                            var quizObjAnswerTwo = {};

                            quizAnswerTwoProperties.forEach(function (quizAnswerTwoProperties) {
                                var quizValue = quizAnswerTwoProperties.split(':');
                                var quizName = quizAnswerTwoProperties.replace(/\s+/g, "").split(':');

                                quizObjAnswerTwo[quizName[0]] = quizValue[0];
                            });

                            dataLayer = window.dataLayer || [];
                            dataLayer.push({
                                'quizAnswerOne': localStorage.getItem('quizAnswerOneText'),
                                'quizAnswerTwo': [quizObjAnswerTwo],
                                'quizAnswerThree': localStorage.getItem('quizAnswerThreeText'),
                                'quizAnswerFour': localStorage.getItem('quizAnswerFourText')
                            });

                            //console.log(dataLayer);

                            // Quiz Push Data layer

                            var quizDays = localStorage.getItem('quizDays');
                            $(".rc_frequencySelecter .rc_frequencySelecter__item[data-handle=" + quizDays + "]").click();
                            $('.c-quizResult__answerTwo').text(localStorage.getItem("quizAnswerTwoText"));

                            setTimeout(function () {
                                localStorage.removeItem('quizId');
                                localStorage.removeItem('quizAnswerOne');
                                localStorage.removeItem('quizAnswerTwo');
                                localStorage.removeItem('quizAnswerThree');
                                localStorage.removeItem('quizAnswerFour');
                                localStorage.removeItem('quizStep');
                                localStorage.removeItem('quizDrops');
                                localStorage.removeItem('quizDescription');
                                localStorage.removeItem('quizAnswerOneIcon');
                                localStorage.removeItem('quizAnswerThreeIcon');
                                //localStorage.removeItem('quizAnswerOneText');
                                //localStorage.removeItem('quizAnswerTwoText');
                                //localStorage.removeItem('quizAnswerThreeText');
                                setListAnswer = [];
                                setListAnswerText = [];
                                /*
                                if (localStorage.getItem("quizAnswerTwoText") !== null) {
                                    $('#QuizAnswerOne').val(localStorage.getItem('quizAnswerOneText'))
                                    $('#QuizAnswerTwo').val(localStorage.getItem('quizAnswerTwoText'))
                                    $('#QuizAnswerThree').val(localStorage.getItem('quizAnswerThreeText'))
                                    $('#QuizAnswerFour').val(localStorage.getItem('quizAnswerFourText'))
                                }*/
                            }, 3000);
                        } else {
                            /*if (localStorage.getItem("quizuseremail") !== null) {
                                pushToKlaviyo();
                            }*/
                            localStorage.removeItem('quizId');
                            localStorage.removeItem('quizAnswerOne');
                            localStorage.removeItem('quizAnswerTwo');
                            localStorage.removeItem('quizAnswerThree');
                            localStorage.removeItem('quizAnswerFour');
                            localStorage.removeItem('quizStep');
                            setListAnswer = [];
                            setListAnswerText = [];

                            localStorage.setItem('quizSubmission', 'done');

                            setTimeout(function () {
                                window.location.href = '/products/the-regimen';
                            }, 3500);
                        }
                    },
                    error: function error(xhr, status) {
                        //console.log('error' , 'submitQuiz function not fired' );
                    }
                });
            };

            if (window.location.href.indexOf("the-regimen") > -1) {
                /*
                if (localStorage.getItem("quizAnswerTwoText") !== null) {
                    $('#QuizAnswerOne').val(localStorage.getItem('quizAnswerOneText'))
                    $('#QuizAnswerTwo').val(localStorage.getItem('quizAnswerTwoText'))
                    $('#QuizAnswerThree').val(localStorage.getItem('quizAnswerThreeText'))
                    $('#QuizAnswerFour').val(localStorage.getItem('quizAnswerFourText'))
                }*/

                if (localStorage.getItem("quizSubmission") == 'done') {

                    if (localStorage.getItem("quizuseremail") !== null) {
                        pushToKlaviyo();
                    }
                    $dom.quizResult.slideDown();
                    $dom.quizResult.addClass('is-open');
                    $dom.quizResult.addClass('c-quizSubmitted');
                    localStorage.removeItem('quizSubmission');
                    // $dom.quizResultDrops.text(localStorage.getItem('quizDrops'));
                    $dom.quizResultDays.text('Ships Every ' + localStorage.getItem('quizDays') + ' Days');
                    $dom.quizRecurringDays.text(localStorage.getItem('quizDays'));
                    $dom.quizResultCopy.text(localStorage.getItem('quizDescription'));
                    $dom.quizResultRow.append("<div class='c-quizResult__item'>" + localStorage.getItem('quizAnswerOneIcon') + "</div>");
                    $dom.quizResultRow.append("<div class='c-quizResult__item'>" + localStorage.getItem('quizAnswerThreeIcon') + "</div>");
                    $('.c-quizResult__answerTwo').text(localStorage.getItem("quizAnswerTwoText"));

                    setTimeout(function () {
                        $(".rc_frequencySelecter .rc_frequencySelecter__item[data-handle=" + localStorage.getItem('quizDays') + "]").click();
                        localStorage.removeItem('quizSubmission');
                        localStorage.removeItem('quizDrops');
                        localStorage.removeItem('quizDescription');
                        localStorage.removeItem('quizAnswerOneIcon');
                        localStorage.removeItem('quizAnswerThreeIcon');
                    }, 2000);

                    setTimeout(function () {
                        //localStorage.removeItem('quizAnswerOneText');
                        //localStorage.removeItem('quizAnswerTwoText');
                        //localStorage.removeItem('quizAnswerThreeText');

                    }, 8000);
                }
            }
            // Quiz Modal Page load using quiz string
            if (window.location.href.indexOf("?quiz") > -1) {
                setTimeout(function () {
                    initPopup();
                    checkUser();
                    getToken();
                }, 3000);
            }

            // Quiz Modal click

            $(document).on("click", '[data-quiz-click]', function () {
                initPopup();
                checkUser();
                getToken();
                return false;
            });

            $dom.quizOverlay.on('click', function () {
                $dom.quizModal.addClass('is-down');
                $('html, body').removeClass('quiz-scroll-hidden');
                return false;
            });

            $dom.quizOutter.on('click', function () {
                if ($($dom.quizModal).hasClass('is-down')) {
                    $dom.quizModal.removeClass('is-down');
                    $('html, body').addClass('quiz-scroll-hidden');
                }
                return false;
            });

            $dom.quizClose.on('click', function () {
                $dom.quizModal.removeClass('is-open');
                $dom.quizModal.removeClass('is-hide-desktop');
                $('html, body').removeClass('quiz-scroll-hidden');
                return false;
            });

            $dom.quizClickDesktop.on('click', function () {
                $dom.quizModal.addClass('is-hide-desktop');
                $('html, body').removeClass('quiz-scroll-hidden');
                return false;
            });

            $dom.quizClickContinue.on('click', function () {
                $dom.quizModal.removeClass('is-hide-desktop');
                $('html, body').addClass('quiz-scroll-hidden');
                return false;
            });

            // Answer selection click
            $dom.quizBlockListType.on('click', function () {
                $dom.quizBlockListType.removeClass('is-active');
                $(this).addClass('is-active');
                $dom.quizBtnStepOne.removeClass('disabled');

                var quizAnswerOne = $(this).find('.c-quizBlockList__name').attr('data-id');
                var quizAnswerOneText = $(this).find('.c-quizBlockList__name').text();
                localStorage.setItem('quizAnswerOne', quizAnswerOne);
                localStorage.setItem('quizAnswerOneText', quizAnswerOneText);
                localStorage.setItem("quizStep", 'one');

                return false;
            });

            $dom.quizListEvent.on('click', function () {
                $(this).toggleClass('is-active');
                var getListAnswer = $(this).attr('data-id');

                if ($(this).hasClass('is-active')) {
                    setListAnswer.push(getListAnswer);
                } else {
                    var removeListAnswer = $(this).attr('data-id');
                    for (var i = setListAnswer.length - 1; i >= 0; i--) {
                        if (setListAnswer[i] === removeListAnswer) {
                            setListAnswer.splice(i, 1);
                        }
                    }
                }

                localStorage.setItem("quizAnswerTwo", setListAnswer.join(','));

                if (setListAnswer.length <= 0) {
                    $dom.quizBtnStepTwo.addClass('disabled');
                } else {
                    $dom.quizBtnStepTwo.removeClass('disabled');
                }

                return false;
            });

            $dom.quizBlockListClimate.on('click', function () {
                $dom.quizBlockListClimate.removeClass('is-active');
                $(this).addClass('is-active');
                $dom.quizBtnStepThree.removeClass('disabled');

                var quizAnswerThree = $(this).find('.c-quizBlockList__name').attr('data-id');
                var quizAnswerThreeText = $(this).find('.c-quizBlockList__name').text();
                localStorage.setItem('quizAnswerThree', quizAnswerThree);
                localStorage.setItem('quizAnswerThreeText', quizAnswerThreeText);
                return false;
            });

            $dom.quizBlockListAge.on('click', function () {
                $dom.quizBlockListAge.removeClass('is-active');
                $(this).addClass('is-active');
                $dom.quizBtnStepFour.removeClass('disabled');

                var quizAnswerFour = $(this).attr('data-id');
                var quizAnswerFourText = $(this).text();
                localStorage.setItem('quizAnswerFour', quizAnswerFour);
                localStorage.setItem('quizAnswerFourText', quizAnswerFourText);
                return false;
            });

            // Back Step on click
            $dom.quizBackStepOne.on('click', function () {
                backStepOne();
            });

            $dom.quizBackStepTwo.on('click', function () {
                backStepTwo();
            });

            $dom.quizBackStepThree.on('click', function () {
                backStepThree();
            });

            // Next Step on click
            $dom.quizBtnStepOne.on('click', function () {
                if (!$($dom.quizBtnStepOne).hasClass('disabled')) {
                    quizBtnStepOne();
                    localStorage.setItem("quizStep", 'two');
                    $dom.quizStepBar.css('width', '50px');
                    $dom.quizContinueBar.css('width', '50px');
                }

                return false;
            });

            $dom.quizBtnStepTwo.on('click', function () {
                if (!$($dom.quizBtnStepTwo).hasClass('disabled')) {
                    quizBtnStepTwo();
                    localStorage.setItem("quizStep", 'three');
                    $dom.quizStepBar.css('width', '80px');
                    $dom.quizContinueBar.css('width', '80px');
                }
                return false;
            });

            $dom.quizBtnStepThree.on('click', function () {
                if (!$($dom.quizBtnStepThree).hasClass('disabled')) {
                    localStorage.setItem("quizStep", 'four');
                    $dom.quizStepBar.css('width', '100%');
                    $dom.quizContinueBar.css('width', '100%');
                    quizBtnStepThree();
                }
                return false;
            });

            $dom.quizBtnStepFour.on('click', function () {
                if (!$($dom.quizBtnStepFour).hasClass('disabled')) {
                    $dom.quizStepBar.css('width', '100%');
                    $dom.quizContinueBar.css('width', '100%');
                    quizBtnStepFour();
                    submitQuiz();
                }
                return false;
            });

            $dom.quizAddToCart.on('click', function () {
                addToCartBtnText.textContent = "Adding to cart..";
                var quizDaysValue = localStorage.getItem('quizDays');
                var itemsArray = [];
                recomendedProducts.map(function (product) {
                    if (!product.classList.contains('c-quizResult__product--oos')) {
                        var discountedPercentage = parseFloat(product.dataset.discountPercentage);
                        var regularPrice = parseFloat(product.dataset.regularPrice) / 100;
                        var discountedPrice = Math.round(regularPrice - regularPrice * discountedPercentage / 100);

                        itemsArray.push({
                            id: product.dataset.varientId,
                            quantity: 1,
                            properties: {
                                "Discount Amount": product.dataset.discountPercentage,
                                "Interval Frequency": "30,45,60",
                                "Interval Unit": "day",
                                "Subscription": quizDaysValue + ' days',
                                "Subscription Amount": discountedPrice + '.00',
                                "Subscription Product Title": product.dataset.subscriptionTitle,
                                "QuizAnswerOne": localStorage.getItem('quizAnswerOneText'),
                                "QuizAnswerTwo": localStorage.getItem('quizAnswerTwoText'),
                                "QuizAnswerThree": localStorage.getItem('quizAnswerThreeText')
                            }
                        });
                    }
                });
                addToCartQuiz(itemsArray);
            });

            function addToCartQuiz(itemsArray) {
                CartJS.addItems(itemsArray);
            }

            $(window).scroll(function () {
                var getQuizResultHeight = $('.c-quizResult').outerHeight();
                if ($(window).scrollTop() > getQuizResultHeight) {
                    if ($($dom.quizResult).hasClass('is-open')) {
                        $dom.quizResult.slideUp();
                        $('.c-quizResult__bar').addClass('is-open');
                        $('body').addClass('is-reco-open');
                    }
                }
            });

            $('.c-quizResult__bar').on('click', function () {
                $(window).scrollTop(0);
                if ($(window).scrollTop() == 0) {
                    $dom.quizResult.slideDown();
                    $('.c-quizResult__bar').removeClass('is-open');
                    $('body').removeClass('is-reco-open');
                }
            });

            if (window.location.href.indexOf("our-story-results") > -1) {

                if (localStorage.getItem("quizAnswerOneText") == 'Dry') {
                    $('.c-storyReportTab__row [data-tab="drycombination"]').click();
                } else if (localStorage.getItem("quizAnswerOneText") == 'Oily') {
                    $('.c-storyReportTab__row [data-tab="oilycombination"]').click();
                } else if (localStorage.getItem("quizAnswerOneText") == 'Normal') {
                    $('.c-storyReportTab__row [data-tab="normal"]').click();
                }
            }
        };

        var init = function init() {
            cacheDom();
            bindUIActions();
        };

        Quiz.init = init;
    })(window.Quiz = window.Quiz || {}, _jquery2.default);
};